module.exports = __webpack_public_path__ + "img/blue-icon(3).a3724b99.png";